<div class="github-select relative w-full">
    <!-- CONTENEDOR DEL SELECT -->
    <div 
      class="relative flex items-center justify-between w-full px-3 py-2 text-xs bg-white  border border-gray-300  rounded-md shadow-sm cursor-pointer hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors duration-200"
      [class.opacity-50]="disabled"
      [class.cursor-not-allowed]="disabled"
      (click)="toggleDropdown($event)"
    > 
      <!-- VALOR SELECCIONADO -->
      <div class="flex items-center min-w-0 flex-1">
        <div class="flex items-center space-x-2 min-w-0">

          <!-- ICONO -->
          <div *ngIf="icon"  class="text-gray-500  flex-shrink-0 flex items-center justify-center transition-colors duration-200">
            <svg class="w-4 h-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="icon"></path>
            </svg>
          </div>
          
          
          <!-- DESCRIPCION DEL VALOR SELECCIONADO -->
          <span 
            class="truncate transition-colors duration-200"
            [class.text-gray-500]="!hasValue"
            [class.text-gray-900]="hasValue"
          >
            {{ displayValue }}
          </span>
        </div>
      </div>
  
      <!-- CHIP DEL VALOR SELECCIONADO -->
      <div *ngIf="selectedOption?.badge" 
       class="ml-2 px-2 py-0.5 text-xs font-medium bg-primary-100  text-primary-800  rounded-full transition-colors duration-200">
        {{ selectedOption!.badge }}
      </div>
  
      <!-- BOTON PARA LIMPIAR EL VALOR SELECCIONADO -->
      <button
        *ngIf="clearable && hasValue && !disabled"
        class="ml-2 p-0 text-gray-400 hover:text-gray-600  transition-colors duration-200"
        (click)="clearSelection($event)"
        type="button"
      >
        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
        </svg>
      </button>
  
      <!-- ICONO FLECHA DESPLEGAR/OCULTAR OPCIONES -->
      <svg 
        class="ml-2 w-4 h-4 text-gray-400  flex-shrink-0 transition-all duration-200"
        [class.rotate-180]="isOpen"
        fill="currentColor" 
        viewBox="0 0 20 20"
      >
        <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path>
      </svg>
    </div>
  
    <!-- MENU DESPLEGABLE -->
    <div 
      *ngIf="isOpen"
      class="absolute z-50 w-full mt-1 bg-white  border border-gray-300  rounded-md shadow-lg transition-colors duration-200"
      [style.max-height]="maxHeight"
    >
      <!-- INPUT DE BUSQUEDA -->
      <div *ngIf="searchable" class="p-2 border-b border-gray-200  transition-colors duration-200">
        <div class="relative">
          <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400  transition-colors duration-200" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path>
          </svg>
          <input
            type="text"
            class="w-full pl-10 pr-4 py-2 text-xs border border-gray-300  rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 bg-white  text-gray-900  transition-colors duration-200"
            [placeholder]="placeholder"
            [value]="searchTerm"
            (input)="onSearchInput($event)"
            (click)="$event.stopPropagation()"
          >
        </div>
      </div>
  
      <!-- TABS -->
      <div *ngIf="showTabs && tabs.length > 0 && !searchTerm.trim()" class="border-b border-gray-200  transition-colors duration-200">
        <div class="flex">
          <button
            *ngFor="let tab of tabs; trackBy: trackByTabId"
            class="flex items-center px-4 py-2 text-xs font-medium border-b-2 transition-colors duration-200"
            [class.border-primary-500]="tab.id === activeTabId"
            [class.text-primary-600]="tab.id === activeTabId"
            [class.border-transparent]="tab.id !== activeTabId"
            [class.text-gray-500]="tab.id !== activeTabId"
            [class.hover:text-gray-700]="tab.id !== activeTabId"
            (click)="switchTab(tab.id)"
          >
            <!-- ICONO DE LA TAB -->
            <svg 
              *ngIf="tab.icon" 
              class="w-4 h-4 mr-2"
              [innerHTML]="tab.icon"
            ></svg>
            
            <!-- DESCRIPCION DE LA TAB -->
            {{ tab.label }}
            
            <!-- CONTADOR DE OPCIONES DE LA TAB -->
            <span 
              *ngIf="tab.count !== undefined" 
              class="ml-2 px-2 py-0.5 text-xs font-medium bg-gray-100  text-gray-600 rounded-full transition-colors duration-200"
            >
              {{ tab.count }}
            </span>
          </button>
        </div>
      </div>
  
       <!-- LISTA DE OPCIONES -->
       <div 
       #optionsContainer
       class="overflow-y-auto" 
       [style.max-height]="getOptionsListHeight()"
       (scroll)="onOptionsScroll($event)"
       >
       <!-- ESTADO DE CARGANDO -->
       <div 
         *ngIf="isLoading" 
         class="px-3 py-4 text-xs text-gray-500  text-center transition-colors duration-200"
       >
         <div class="flex items-center justify-center space-x-2">
           <svg class="animate-spin h-4 w-4 text-gray-400  transition-colors duration-200" fill="none" viewBox="0 0 24 24">
             <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
             <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
           </svg>
           <span>Buscando...</span>
         </div>
       </div>

       <!-- ESQUELETO DE CARGANDO -->
       <div *ngIf="isLoading && !isLoadingMore">
         <div 
           *ngFor="let item of getSkeletonItems()"
           class="flex items-center justify-between px-3 py-2 animate-pulse"
         >
           <div class="flex items-center space-x-2 min-w-0 flex-1">
             <!-- Skeleton icon -->
             <div class="w-4 h-4 bg-gray-200  rounded flex-shrink-0 transition-colors duration-200"></div>
             
             <!-- Skeleton label -->
             <div class="h-4 bg-gray-200  rounded flex-1 transition-colors duration-200" style="max-width: 200px;"></div>
           </div>
           
           <!-- Skeleton badge -->
           <div class="w-12 h-4 bg-gray-200  rounded flex-shrink-0 transition-colors duration-200"></div>
         </div>
       </div>

       <!-- OPCIONES -->
       <div 
         *ngFor="let option of filteredOptions; trackBy: trackByValue"
         class="flex items-center justify-between px-3 py-2 text-xs cursor-pointer  hover:bg-gray-50  transition-colors duration-150"
         [class.bg-primary-50]="option.value === value"
         [class]="option.value === value ? '' : ''"
         [class.text-gray-400]="option.disabled"
         [class.cursor-not-allowed]="option.disabled"
         (click)="selectOption(option)"
       >

        <!-- DESCRIPCION DE LA OPCION -->
        <div class="flex items-center space-x-2 min-w-0 flex-1">
          <span class="truncate text-gray-900 transition-colors duration-200">{{ option.label }}</span>
        </div>

         <!-- CHIP DE LA OPCION -->
         <div *ngIf="option.badge" 
              class="ml-2 px-2 py-0.5 text-xs font-medium bg-gray-100  text-gray-700 rounded-full flex-shrink-0 transition-colors duration-200">
           {{ option.badge }}
         </div>

         <!-- ICONO DE LA OPCION SELECCIONADA -->
         <svg 
           *ngIf="option.value === value" 
           class="ml-2 w-4 h-4 text-primary-600 flex-shrink-0"
           fill="currentColor" 
           viewBox="0 0 20 20">
           <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
         </svg>
       </div>

       <!-- OPCION PARA CREAR NUEVA -->
       <div 
         *ngIf="shouldShowCreateOption"
         class="flex items-center justify-between px-3 py-2 text-xs cursor-pointer border-t border-gray-200  hover:bg-primary-50  transition-colors duration-150"
         (click)="selectOption(createNewOption)"
       >
         <div class="flex items-center space-x-2 min-w-0 flex-1">
           <svg class="w-4 h-4 text-primary-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
             <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
           </svg>
           <span class="truncate text-primary-600  font-medium transition-colors duration-200">{{ createNewOption.label }}</span>
         </div>
       </div>

       <!-- ESQUELETO DE CARGANDO MAS OPCIONES -->
       <div *ngIf="isLoadingMore" class="px-3 py-2">
         <div 
           *ngFor="let item of getSkeletonItems()"
           class="flex items-center justify-between py-2 animate-pulse"
         >
           <div class="flex items-center space-x-2 min-w-0 flex-1">
             <!-- Skeleton icon -->
             <div class="w-4 h-4 bg-gray-200  rounded flex-shrink-0 transition-colors duration-200"></div>
             
             <!-- Skeleton label -->
             <div class="h-4 bg-gray-200  rounded flex-1 transition-colors duration-200" style="max-width: 200px;"></div>
           </div>
           
           <!-- Skeleton badge -->
           <div class="w-12 h-4 bg-gray-200  rounded flex-shrink-0 transition-colors duration-200"></div>
         </div>
       </div>

       <!-- MENSAJE DE RESULTADOS VACIOS -->
       <div 
         *ngIf="!isLoading && !isLoadingMore && filteredOptions.length === 0 && searchTerm.length >= minSearchLength && !shouldShowCreateOption" 
         class="px-3 py-4 text-xs text-gray-500  text-center transition-colors duration-200"
       >
         No se encontraron resultados
       </div>

       <!-- ESTADO INICIAL PARA LA BUSQUEDA DINAMICA -->
       <div 
         *ngIf="!isLoading && !isLoadingMore && dynamicSearch && filteredOptions.length === 0 && searchTerm.length < minSearchLength" 
         class="px-3 py-4 text-xs text-gray-500  text-center transition-colors duration-200"
       >
         Escribe al menos {{ minSearchLength }} caracteres para buscar
       </div>

       <!-- MENSAJE DE FIN DE LOS RESULTADOS -->
       <div 
         *ngIf="!isLoading && !isLoadingMore && paginationInfo && !paginationInfo.tiene_pagina_siguiente && filteredOptions.length > 0" 
         class="px-3 py-2 text-xs text-gray-400  text-center border-t border-gray-100  transition-colors duration-200"
       >
         Fin de los resultados ({{ paginationInfo.total_registros }} total)
       </div>
     </div>
    </div>
  </div>
  